import { TFunction } from 'i18next'

import { AddressingLineLookupStatus } from '../enums/addressingLineLookupStatus'

export const getAddressingLineLookupErrorMessage = (
  t: TFunction,
  lookupStatus?: AddressingLineLookupStatus,
): string | undefined => {
  switch (lookupStatus) {
    case AddressingLineLookupStatus.Invalid:
      return t('external_invoices.send_as_e_invoice.modal.field.addressing_line.error.invalid_format')
    case AddressingLineLookupStatus.Unavailable:
      return t('external_invoices.send_as_e_invoice.modal.field.addressing_line.error.unavailable')
    case AddressingLineLookupStatus.Unmatched:
      return t('external_invoices.send_as_e_invoice.modal.field.addressing_line.error.not_found')
    default:
      return undefined
  }
}
